import React from "react";

import { dFlex, formulaStyle, division } from "./styles";

const DivFormula = ({ name1, name2, name3, sm = false }) => (
  <div style={{ ...dFlex, ...formulaStyle(sm), alignItems: "center" }}>
    {name1} =
    <div style={division}>
      {name2}
      <hr
        style={{ height: "1px", backgroundColor: "#8F8F8F", width: "100%" }}
      />
      {name3}
    </div>
  </div>
);

export default DivFormula;



// WEBPACK FOOTER //
// ./src/components/analysis/DivFormula.js